import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import cruz from './assets/cruz.webp';
import henderson from './assets/henderson.webp';
import judge from './assets/judge.webp';
import ohtani from './assets/ohtani.webp';
import ramirez from './assets/ramirez.webp';
import skenes from './assets/skenes.webp';
import skubal from './assets/skubal.webp';
import tatis from './assets/tatis.webp';
import witt from './assets/witt.webp';

type OnboardingCard = {
  slug?: string;
  cardImg: string;
};

const defaultPlayers: OnboardingCard[] = [
  'https://assets.sorare.com/image-resize/card/8d87dda4-76d9-4d2e-9537-aea93e3e6cda/picture/tinified-a8b89eb6d1d2b2cb1e526d27bb10b78d.png?width=320&xl=true',
  'https://assets.sorare.com/image-resize/card/b86da81c-098b-4719-92ec-761bc56f8a4d/picture/tinified-91faed4605fb43daec66bde97741da39.png?width=320&xl=true',
  'https://assets.sorare.com/image-resize/card/460f5159-48cc-4640-9469-a9bcaf9d6fac/picture/tinified-dbb3f41445ef0e51bb67aa812a57ea15.png?width=320&xl=true',
  'https://assets.sorare.com/image-resize/card/712cda7d-3a2e-4e46-9768-2cf65b352b8b/picture/tinified-027ef01ba691ff9a17e800e9554b3c2c.png?width=320&xl=true',
  'https://assets.sorare.com/image-resize/card/ae29a762-ace5-4e58-abf2-fcc4834608c7/picture/tinified-22a4df3d31d5a51cf259876db4b93df1.png?width=640&xl=true',
  'https://assets.sorare.com/image-resize/card/d2ffa4ca-7a39-4c56-8fde-069ac59f3e52/picture/tinified-05c141d9bec06f42d284907bb4a556da.png?width=320&xl=true',
  'https://assets.sorare.com/image-resize/card/3a973cae-7962-4adb-8019-a052d0ea5d4b/picture/tinified-534804303cc74860590caa75d87a7e55.png?width=320&xl=true',
  'https://assets.sorare.com/image-resize/card/9efb5008-10f3-44e7-9263-4c03b56ba776/picture/tinified-407a97ccd23306994245fe7dc9d8f304.png?width=320&xl=true',
  'https://assets.sorare.com/image-resize/card/c6ca0386-df30-4c12-abe6-ec8c08f19491/picture/tinified-89f78996a5b8f91f033c8724de85b48f.png?width=320&xl=true',
].map(cardImg => ({ cardImg }));

const mlbPlayers: OnboardingCard[] = [
  skubal,
  ramirez,
  henderson,
  tatis,
  judge,
  ohtani,
  witt,
  skenes,
  cruz,
].map(cardImg => ({ cardImg }));

export const useOnboardingCardImages = (): OnboardingCard[] => {
  const { sport } = useSportContext();
  const {
    flags: { footballOnboardingPlayersData },
  }: { flags: { footballOnboardingPlayersData?: OnboardingCard[] } } =
    useFeatureFlags();

  const cardsBySport: Record<Sport, OnboardingCard[]> = {
    [Sport.FOOTBALL]: footballOnboardingPlayersData || [],
    [Sport.BASEBALL]: mlbPlayers,
    [Sport.NBA]: defaultPlayers,
  };

  return cardsBySport[sport];
};
